<div class="modal-header">
  <h5 class="modal-title" id="stationAddLabel" i18n="@@AddRfidCardHeader">RFID-Karte hinzufügen</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>
<div class="modal-body">
  <app-create-rfid-card #createRfidCardComponent></app-create-rfid-card>
</div>
<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-yellow" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Schließen</button>
  <form [formGroup]="formService.form" (ngSubmit)="createRfidCardComponent.onSubmit(formService.form.value)">
    <button type="submit" id="add" class="btn btn-yellow" [disabled]="!formService.form.valid" i18n="@@AddRfidCardButton">RFID-Karte Hinzufügen</button>
  </form>
</div>
